import TemplatesGuest from './TemplatesGuest'
export default TemplatesGuest
